import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { translation } from '../../../i18n';
import { observer } from 'mobx-react';
import { EmployeeDto } from '../../user/userTypes';
import { getSelfActual } from '../questionnaireApi';
import TitleMessagePage from '../../../components/emptyPage/TitleMessagePage';
import { withQuestionnaire } from '../../../router/Loaders';
import QuestionnaireComponent from '../../../components/questionnaire/unansweredQuestionnaire/QuestionnaireComponent';

type LocalStyles = 'root';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
    padding: theme.spacing.unit * 4,
  },
});

interface Props {
  renderSearch: (showSearch: boolean) => void;
  currentEmployee: EmployeeDto;
}

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class SelfActual extends React.Component<PropsWithStyle> {

  constructor(props: PropsWithStyle) {
    super(props);
    this.props.renderSearch(false);
  }

  public render() {
    return (
      <>
        {
          withQuestionnaire(
            getSelfActual,
            questionnaire =>
              <QuestionnaireComponent
                errorPage={
                  <TitleMessagePage
                    title={translation.t('actualComponent.self.title')}
                    message={translation.t('actualComponent.body')}/>
                }
                questionnaire={questionnaire}
                currentEmployee={this.props.currentEmployee}/>)
        }
      </>
    );
  }
}

export default withStyles(localStyles)(SelfActual);
